import ContentLoader from 'react-content-loader'

export const MeetingsSkeleton = () => (
    <ContentLoader speed={2} width={300} height={250} viewBox="0 0 800 250" backgroundColor="#f3f3f3" foregroundColor="#ecebeb">
        <rect x="0" y="0" rx="3" ry="3" width="230" height="250" />
        <rect x="240" y="0" rx="3" ry="3" width="230" height="250" />
        <rect x="480" y="0" rx="3" ry="3" width="230" height="250" />
    </ContentLoader>
)
